module.exports = __webpack_public_path__ + "static/img/injectionProductionBanner.f41d2a04.png";